import { AppSpecifiedSearchQueryBuildService } from 'common/services/search/commonSearchQueryBuilder';
import { CustomFieldDefinitionTypes } from 'common/store/common/constants';

import store from '../../store';
import { RootState } from '../../store/rootReducer';

import * as sectionFields from '../../../docs/definitions/sectionFields.json';
import * as authorFilterColumns from '../../../docs/definitions/authorFilterColumns.json';
import * as questionStimulusDefaultColumns from '../../../docs/definitions/questionStimulusDefaultColumns.json';
import customFieldsService from '../metadata/customFieldsService';
import { isQuestionMode } from 'common/util/shared/sharedUtils';
import {
    AI_ELIGIBLE_COLUMN_REF,
    isAiMarkingMarketplaceEnabled,
} from '../../features/addQuestions/services/aiAssistedMarkingService';

const isAiEligibleColumnEnabled = (column: { ref?: string }, dataType?: string): boolean => (
    column?.ref !== AI_ELIGIBLE_COLUMN_REF
    || (dataType === CustomFieldDefinitionTypes.QUESTION && isAiMarkingMarketplaceEnabled())
);

const searchQueryBuilderService: AppSpecifiedSearchQueryBuildService = {
    getColumnsDefinition(dataType?: string, featureId?: string) {
        let defaultColumns;
        switch (dataType) {
        case CustomFieldDefinitionTypes.QUESTION:
        case CustomFieldDefinitionTypes.QUESTION_SET:
        case CustomFieldDefinitionTypes.SECTION:
            defaultColumns = isStimulusQuestionItemBank() ? 
                questionStimulusDefaultColumns.default :
                authorFilterColumns.default ?? authorFilterColumns;
                if (featureId) {
                const rootState: RootState = store.getState() as RootState;
                const { customFieldsDefinition } = rootState;

                if (customFieldsDefinition[dataType]?.length) {
                    defaultColumns = defaultColumns.concat(
                        customFieldsService.getCustomFieldsAsColumnDefinitions(customFieldsDefinition[dataType])
                    );
                }
            }
            break;
        default:
            defaultColumns = sectionFields.default ? sectionFields.default : sectionFields;
        }

        return (defaultColumns || []).filter((column: { ref?: string }) => isAiEligibleColumnEnabled(column, dataType));
    },

};

export const isStimulusQuestionItemBank = () => {
    return window.marketplaceProperties.ENABLE_ADD_STIMULUS_FROM_BANK && isQuestionMode();
}

export default searchQueryBuilderService;
